export const colors = {
  brandNavy: '#081e4d', // .com blue (primary)
  brandBlue: '#2563EB', // accent blue
  brandBlueDark: '#1E40AF',
  brandOrange: '#F17E28',
  brandOrangeDark: '#CE5F0D',
  brandNavy700: '#1E3A8A',
  brandBlue50: '#EEF2FF',
  danger: '#DC2626',
  danger700: '#B91C1C',
  ring: '#60A5FA',
  text: '#111827',
  muted: '#6B7280',
  surface: '#FFFFFF',
  border: 'rgba(0,0,0,0.08)',
  navyHighlightshade1: '#ececff',
  navyHighlightshade2: '#1b3f94',
  navyHighlightshade3: '#2b56c2',
  navyHighlightshade4: '#3f6cf5',

  // Chips
  orangeSoftBg: '#FFF6ED',
  orangeBorder: '#F19A5C',
  mutedChip: '#6B7280',
  surfaceChip: '#FFFFFF',
  borderChip: 'rgba(0,0,0,0.12)',
  unselectedBorder: '#D1D5DB',
  textChip: '#111827',

  // Buttons
  BLUE_TOP: '#143a8b',
  BLUE_BOTTOM: '#081e4d',
  BLUE_BORDER: '#0f2f73',

  // Hover (brighter)
  BLUE_HOVER_TOP: '#1b4ca8',
  BLUE_HOVER_BOTTOM: '#0e2f6a',
  BLUE_HOVER_BORDER: '#1950b0',

  // active (pressed - darker)
  BLUE_ACTIVE_TOP: '#061a42',
  BLUE_ACTIVE_BOTTOM: '#041235',
  BLUE_ACTIVE_BORDER: '#051e49',

  RED_TOP: '#F97066',
  RED_BOTTOM: '#D92D20',
  RED_BORDER: '#D92D20',
};
